import React, { useState } from "react";
import "../../assets/styles/styleUser.css";
import Header from "../../layoutUser/header/header";
import Sidebar from "../../layoutUser/sidebar/sidebar";
import MyBookings from "../../layoutUser/center/myBookings";
import useMediaQuery from "@mui/material/useMediaQuery";
function BookingUser(props) {
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const [searchBook, setSearchBook] = useState(''); 
  const handleSearch = (term) => {  
    setSearchBook(term);
  };

  return (
    <div className="container">
     <Header placeholder={'Search order by place, braid or status'} isHomePage={false} onSearch={handleSearch}/>
     {
        isSmallScreen?null: <Sidebar />
      }
      <MyBookings searchBook={searchBook} />
    </div>
  );
}

export default BookingUser;